import * as React from 'react';
export const chevronUpSvg = React.forwardRef(function chevronUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.381 11.619a.875.875 0 0 0 1.238 0L8 5.237l6.381 6.382a.875.875 0 1 0 1.238-1.238l-7-7a.875.875 0 0 0-1.238 0l-7 7a.875.875 0 0 0 0 1.238Z',
    }),
  );
});
chevronUpSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronUp = {
  category: 'icon',
  colorable: true,
  name: 'chevronUp',
  svg: chevronUpSvg,
};
